export default {
    // Button state constants
    STATE_INACTIVE: 'inactive',
    STATE_ACTIVE: 'active',
};



// WEBPACK FOOTER //
// ./src/web/js/entry/consts/button-states.js